<!--
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-10-09 11:33:21
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-11-01 10:12:40
 * @FilePath: \standard-v5\src\views\OpinionPublish\detail\Organ.vue
 * @Description: 意向发布-选择测绘机构
-->

<template>
  <div class="organ">
    <div class="search-box">
      <van-search 
        v-model="params.dwmc" placeholder="请输入搜索关键词" show-action
        @search="search" @cancel="onCancel"
      />
      <div class="condition">
        <div v-for="(item, i) in queryConfig" :key="i">
          <div class="condition-item" :class="{ 'active': active==i }" @click="clickCondition(i)" v-show="item.optionKey">
            <span>{{ item.optionName }}<van-icon name="arrow-down" /></span>
          </div>
        </div>
        <!-- <div class="condition-item" :class="{ 'active': active==0 }" @click="clickCondition(0)">
          {{ queryConfig[0].optionName }} <van-icon name="arrow-down" />
        </div>
        <div class="condition-item" :class="{ 'active': active==1 }" @click="clickCondition(1)" v-if="params.zcdzs=='4401'">
          {{ queryConfig[1].optionName }} <van-icon name="arrow-down" />
        </div>
        <div class="condition-item" :class="{ 'active': active==2 }" @click="clickCondition(2)">
          {{ queryConfig[2].optionName }} <van-icon name="arrow-down" />
        </div>
        <div class="condition-item" :class="{ 'active': active==3 }" @click="clickCondition(3)">
          {{ queryConfig[3].optionName }} <van-icon name="arrow-down" />
        </div> -->
      </div>
    </div>
    <no-data v-if="list.length == 0"></no-data>
    <div class="organ-box" ref="organBox">
      <van-checkbox-group v-model="componentData.data" class="organ-list" ref="organList" @change="checkboxChange">
        <div class="organ-list-item" v-for="(item, idx) in list" :key="idx">
          <van-checkbox :name="item.dwmc">
            <div class="content">
              <div class="title">{{ item[columns[0].key] }}</div>
              <div v-for="(column, index) in columns" :key="index">
                <div class="cell-box" v-if="column.key != columns[0].key">
                  <span class="cell-box-title">{{ column.label }}</span>
                  <div class="cell-box-value">
                    {{ item[column.key] }}
                  </div>
                </div>
              </div>
              <van-cell
                title="详情"
                is-link
                class="detail-btn"
                title-class="detail-title"
                @click="itemClicked(item)"
              />
            </div>
          </van-checkbox>
        </div>
      </van-checkbox-group>
    </div>
    <div class="all">
      <van-checkbox v-model="componentData.selectAll" @change="changeAll">全选</van-checkbox>
      <span>合计：{{ componentData.data.length }}条</span>
    </div> 
    <van-popup v-model="showPopup" round position="bottom">
      <van-picker
        title="选择"
        show-toolbar
        :columns="pickerColumns"
        value-key="showValue"
        @confirm="onConfirm"
        @cancel="showPopup = false"
      />
    </van-popup>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
// import api from '@/utils/api/opinionPublish'
import unitApi from '@/utils/api/jobUnitQuery.api.js'
// import moduleMixins from '@/mixins/moduleMixins'
import { mapGetters } from 'vuex'
export default {
  components: {
    NoData
  },
  // mixins: [ moduleMixins ],
  props: {},
  data() {
    return {
      // componentData: {
      //   componentDesc: "发布对象",
      //   data: [],
      //   permission: {
      //     limitZoneByProjInfo: false,
      //     isTemporarySave: true
      //   },
      //   componentName: "release",
      //   isShow: true,

      //   ignoreData: [],
      //   selectAll: false,
      //   searchParams: {}
      // },
      componentData: {
        data: [],
        ignoreData: [],
        selectAll: false,
      },
      params: {
        page: 1,
        size: 10,
        dwmc: '', // 搜索条件
        zzdj: '', // 资质等级
        zcdzs: '', // 服务区域
        qxq: '',  // 区县\旗
        zhpj: '', // 综合评价

        dwxz: "",
        dateStart: "",
        dateEnd: "",
        sort: "",
        sortType: true,
      },
      list: [],
      columns: [], // 列表子项的左侧标题数组
      canscroll: true, 
      activeisload: true,
      queryConfig: [],
      active: null,
      showPopup: false,
      pickerColumns: [],
    };
  },
  watch: {},
  computed: {
    ...mapGetters('opinion', ['getOpinionData']),
    // navTitle() {
    //   return '选择测绘机构'
    // },
  },
  methods: {
    // 搜索测绘作业
    search(val) {
      console.log('搜索值', val)
      this.params.page = 1
      this.params.dwmc = val
      this.getData()
    },
    // 取消搜索
    onCancel() {
      console.log('点击取消')
      this.params.page = 1
      this.params.dwmc = ''
      this.getData()
    },
    clickCondition(i) {
      this.active = i
      let [ ...arr ] = this.queryConfig[i].option
      arr.unshift({
        showValue: '不限',
        code: '',
        child: null,
      })
      this.pickerColumns = arr
      this.showPopup = true
    },
    onConfirm(val) {
      console.log(val)
      this.params[this.queryConfig[this.active].optionKey] = val.code
      // 判断服务区域是否有child，有就将其插进数组第二位，
      let qItem = this.queryConfig[this.active]
      if(qItem.optionName=='服务区域' && (qItem.option[0] && qItem.option[0].child)) {
        // this.queryConfig.splice(1, 0, this.queryConfig[0].option[0].child)
        this.queryConfig[1] = this.queryConfig[0].option[0].child
      }
      // 没有就将数组第二个对象清掉
      if(this.params.zcdzs=='') {
        this.queryConfig[1] = { optionKey: '' }
      }
      console.log(qItem)
      if(this.active==0) {
        this.params.qxq = ''
      }
      this.showPopup = false
      this.getData()
    },
    checkboxChange(val) {
      if(this.componentData.selectAll) {
        console.log(val)
        this.componentData.ignoreData = []
        this.list.forEach(item => {
          if(!val.includes(item.dwmc)) {
            this.componentData.ignoreData.push(item.dwmc)
          }
        })
      }
    },
    changeAll(val) {
      console.log(val)
      this.$refs['organList'].toggleAll(val)
    },
    // 点击"详情"按钮，查看详情
    itemClicked(data) {
      console.log('--详情--', data, data[this.columns[0].key])
      this.$router.push({
        name: 'jobUnitQueryDetail',
        params: {
          rid: data.rid,
          unitName: data[this.columns[0].key],
          userid: data.userid
        }
      })
    },
    //加载获取项目进度查询和办理列表
    getData() {
      unitApi.getJobUnitQueryList(this.params).then(res => {
        console.log('--res', res.data.rowsList)
        let data = res.data
        this.columns = data.columns
        if(this.params.page==1 || (this.params.page==1 && !data.rowsList.length)) this.list = []
        if (data.rowsList.length) {
          // this.list = this.list.concat(data.rowsList)
          this.list.push(...data.rowsList)
          if (data.rowsList.length < this.params.rows) {
            this.activeisload = false;
            console.log("已加载完");
          } else {
            this.canscroll = true;
          }
        }
      })
    },
    getQueryConfig() {
      unitApi.getQueryConfig().then(res => {
        res.data.downOption.forEach((item,i) => {
          this.$set(this.queryConfig, i, item)
        })
        this.queryConfig.splice(1, 0, {
          optionKey: ''
        })
      })
    }
  },
  created() {
    this.getData()
    this.getQueryConfig()
    this.componentData = this.getOpinionData(3)
    // this.componentData = this.$parent.allData[3]
  },
  mounted() {
    this.$nextTick(() => {
      let organBox = this.$refs['organBox']
      let organList = this.$refs['organList'].$el
      console.log(this.$refs, organList, organBox, organBox.offsetHeight)
      organBox.addEventListener("scroll", () => {
        if (this.canscroll) {
          let scroll_top = organBox.scrollTop
          let list_height = organList.offsetHeight
          let box_height = organBox.offsetHeight
          
          // console.log(list_height, scroll_top + box_height, list_height - (scroll_top + box_height) < 100)
          if (list_height - (scroll_top + box_height) < 200) {
            this.canscroll = false; //锁定滚动触发条件
            if (this.activeisload) {
              this.params.page++
              this.getData()
            } else {
              console.log("已加载完所有已收藏的商品");
            }
          }
        }
      })
    })
  }
};
</script>
<style lang="scss" scoped>
.organ {
  height: calc(100vh - 190px);
  width: 100%;
  .search-box {
    width: 100%;
    min-height: 80px;
    background-color: #fff;
    position: fixed;
    top: 0;
    z-index: 1;
    .condition {
      display: flex;
      padding: 0 15px 10px;
      font-size: 14px;
      background-color: #fff;
      &-item {
        span {
          margin-right: 20px;
        }
        &.active {
          color: #1d84ff;
        }
      }
    }
  }
  .organ-box {
    width: 100%;
    height: 100%;
    margin-top: 85px;
    padding-bottom: 20px;
    background: #f1f3f6;
    overflow-y: auto;
    box-sizing: border-box;
    .organ-list {
      .organ-list-item {
        margin: 0px 16px 0px 10px;
        padding-top: 20px;
        ::v-deep .van-checkbox__label {
          flex: 1;
        }
        .content {
          box-shadow: 0px 2px 5px 0px rgba(124, 130, 140, 0.2);
          border-radius: 5px;
          background: #ffffff;
          .title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
            padding: 15px 0px 17px 15px;
          }
          .cell-box {
            display: flex;
            padding: 0px 15px 17px 10px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            width: calc(100% - 25px);
            .cell-box-title {
              color: #999999;
              width: 25%;
              display: flex;
              justify-content: flex-end;
            }
            .cell-box-value {
              width: 75%;
              padding-left: 18px;
            }
          }
          .detail-btn {
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            border-top: 1px solid #f1f3f6;
          }
          .detail-title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }
        }
      }
    }
  }
  .all {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    background-color: #fff;
    position: fixed;
    left: 0;
    bottom: 65px;
    display: flex;
    align-items: center;
    span {
      margin-left: 20px;
      font-size: 15px;
      color: #1D84FF;
    }
  }
}
</style>